import request from "@/utils/request";

export default function agencyGetNewsMessageTemplates() {
    return request({
        url: `/agencyNewsMessageTemplate/agencyGetNewsMessageTemplates`,
        method: 'get',
    })
}
